<template>
  <div class="networkingsingup">

    <div class="header" style="margin-bottom:10px;margin-top:14px">
      <div class="header-body">
        <div class="layout clearfix">
          <div class="img-wrapper"> <img
              src="https://www.ttcdw.com.cn/storage/group1/M00/2A/13/CgoAGGgawNCAYdhWAAK7j256YBY219.jpg"
              onerror="nofind()"> </div>
          <div class="info-wrapper">
            <div class="state not-begin clearfix"><span class="title proNameTitle"
                style="max-height:60px;word-break:break-all;overflow:hidden;white-space:unset;overflow:hidden;text-overflow:unset">山西省第三届家庭教育指导技能大赛（社会成人）</span>
            </div>
            <div class="courseRelation">
              <p class="text" style="font-size:16px"><span style="font-size:16px">山西省家庭教育服务平台</span><span
                  style="border-left:2px solid #eaeaea;padding-left:15px;margin-left:15px"><i
                    class="glyphicon glyphicon-share"></i>分享 </span><span class="social-share share-component"
                  data-wechat-qrcode-title="请打开微信扫一扫"><a class="social-share-icon icon-qq"
                    href="http://connect.qq.com/widget/shareqq/index.html?url=https%3A%2F%2Forg.ttcdw.cn%2Fproject%2F983123849693712384&amp;title=%E4%B8%AA%E4%BA%BA%E6%97%A5%E5%BF%97&amp;source=%E5%B1%B1%E8%A5%BF%E7%9C%81%E7%AC%AC%E4%B8%89%E5%B1%8A%E5%AE%B6%E5%BA%AD%E6%95%99%E8%82%B2%E6%8C%87%E5%AF%BC%E6%8A%80%E8%83%BD%E5%A4%A7%E8%B5%9B%EF%BC%88%E7%A4%BE%E4%BC%9A%E6%88%90%E4%BA%BA%EF%BC%89&amp;desc=your%20description&amp;pics=https%3A%2F%2Fwww.ttcdw.com.cn%2Fstorage%2Fgroup1%2FM00%2F2A%2F13%2FCgoAGGgawNCAYdhWAAK7j256YBY219.jpg&amp;summary=&quot;your%20description&quot;"
                    target="_blank"></a><a class="social-share-icon icon-qzone"
                    href="http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=https%3A%2F%2Forg.ttcdw.cn%2Fproject%2F983123849693712384&amp;title=%E4%B8%AA%E4%BA%BA%E6%97%A5%E5%BF%97&amp;desc=your%20description&amp;summary=your%20description&amp;site=%E5%B1%B1%E8%A5%BF%E7%9C%81%E7%AC%AC%E4%B8%89%E5%B1%8A%E5%AE%B6%E5%BA%AD%E6%95%99%E8%82%B2%E6%8C%87%E5%AF%BC%E6%8A%80%E8%83%BD%E5%A4%A7%E8%B5%9B%EF%BC%88%E7%A4%BE%E4%BC%9A%E6%88%90%E4%BA%BA%EF%BC%89&amp;pics=https%3A%2F%2Fwww.ttcdw.com.cn%2Fstorage%2Fgroup1%2FM00%2F2A%2F13%2FCgoAGGgawNCAYdhWAAK7j256YBY219.jpg"
                    target="_blank"></a><a class="social-share-icon icon-wechat" href="javascript:">
                    <div class="wechat-qrcode" style="display: none">
                      <h4>请打开微信扫一扫</h4>
                      <div class="qrcode" title="https://org.ttcdw.cn/project/983123849693712384"><canvas width="100"
                          height="100" style="display: none;"></canvas><img alt="Scan me!"
                          src="data:image/png;base64,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"
                          style="display: block;"></div>
                      <div class="help">
                        <p>微信里点“发现”，扫一下</p>
                        <p>二维码便可将本文分享至朋友圈。</p>
                      </div>
                    </div>
                  </a>
                  <a class="social-share-icon icon-weibo"
                    href="https://service.weibo.com/share/share.php?url=https%3A%2F%2Forg.ttcdw.cn%2Fproject%2F983123849693712384&amp;title=%E4%B8%AA%E4%BA%BA%E6%97%A5%E5%BF%97&amp;pic=https%3A%2F%2Fwww.ttcdw.com.cn%2Fstorage%2Fgroup1%2FM00%2F2A%2F13%2FCgoAGGgawNCAYdhWAAK7j256YBY219.jpg&amp;appkey="
                    target="_blank"></a>
                </span>
              </p>
              <p class="text b5">项目时间：2025-05-07 至 2025-09-28 <span class="lable mr20 proState">进行中</span> </p>
              <p class="text mb5">报名时间：2025-05-07 至 2025-09-25 </p>
            </div>
            <div class="clearfix" style="margin-top:15px"> <a class="btn btn-default"
                @click="toPage('/networkingsingup/project')">进入项目</a> </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout clearfix">
      <div class="container">
        <ul class="nav nav-tabs">
          <li :class="[tabActive===0?'on':'']" data-type="0" @click="tabFun(0)">项目简介</li>
          <li data-type="1" :class="[tabActive===1?'on':'']" @click="tabFun(1)">报名说明</li>
        </ul>
        <div class="tab-content" style="margin-top:20px" id="myTabContent">
          <div class="tabContent" id="tabContent1" v-if="tabActive===0">
            项目简介
          </div>
          <div class="tabContent" id="tabContent2" v-if="tabActive===1">
            报名说明
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      tabActive: 0
    }
  },
  components: {

  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },
  computed: {

  },
  methods: {
    toPage(page) {
      this.$router.push(page)
    },
    tabFun(index) {
      this.tabActive = index
    }
  },

}
</script>
<style lang="scss" scoped>
.networkingsingup {
  background-color: #f4f4f4;
  min-height: calc(100vh - 74px);

  .clearfix:before,
  .clearfix:after {

    display: table;
    content: " ";
    box-sizing: border-box;
  }

  .layout {
    width: 1200px;
    margin: 13px auto;
  }

  .header {
    .header-body {
      .layout {
        position: relative;
        padding: 30px 15px;
        width: 1200px;
        height: 260px;
        background: #fff !important;
        margin: 13px auto;

        .img-wrapper {
          float: left;
          width: 350px;
          height: 200px;

          img {
            width: 350px;
            height: 200px;
          }
        }

        .info-wrapper {
          float: left;
          width: 800px;
          margin-left: 20px;

          .state {
            margin: -3px 0 14px;
            font-size: 0;
          }











          .not-begin {
            color: #333;
          }

          .btn-default {
            color: #333;
            background-color: #4286f5;
            border-color: #4286f5;
            color: #fff;
            width: 102px;
          }

          .btn {
            display: inline-block;
            padding: 6px 12px;
            margin-bottom: 0;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.42857143;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -ms-touch-action: manipulation;
            touch-action: manipulation;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            background-image: none;
            border: 1px solid transparent;
            border-radius: 4px;
          }

          .courseRelation {
            color: #555;
            line-height: 20px;


            .text {
              font-size: 16px;
              color: #555;
              margin-bottom: 4px;
              line-height: initial;

              .glyphicon {
                position: relative;
                top: 1px;
                display: inline-block;
                font-family: 'Glyphicons Halflings';
                font-style: normal;
                font-weight: normal;
                line-height: 1;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
              }

              .glyphicon-share:before {
                content: "\e066";
              }


              .proState {
                color: #fff;
                background: #f90;
                margin-left: 0;
                padding: 5px;
              }

              .lable {
                height: 18px;
                line-height: 18px;
                padding: 0 7px;
                text-align: center;
                font-size: 12px;
                border-radius: 9px;
                margin: 0 0 0 6px;
                vertical-align: 1px;
              }





              .social-share {
                font-family: "socialshare" !important;
                font-size: 16px;
                font-style: normal;
                -webkit-font-smoothing: antialiased;
                -webkit-text-stroke-width: 0.2px;
                -moz-osx-font-smoothing: grayscale;

                .social-share-icon {
                  position: relative;
                  display: inline-block;
                  width: 32px;
                  height: 32px;
                  font-size: 20px;
                  border-radius: 50%;
                  line-height: 32px;
                  border: 1px solid #666;
                  color: #666;
                  text-align: center;
                  vertical-align: middle;
                  transition: background 0.6s ease-out 0s;
                  width: 28px;
                  height: 28px;
                  font-size: 16px;
                  line-height: 28px;
                }

                a {
                  position: relative;
                  text-decoration: none;
                  margin: 4px;
                  display: inline-block;
                  outline: none;
                }

                .icon-qq {
                  color: #56b6e7;
                  border-color: #56b6e7;
                }

                .icon-qzone {
                  color: #FDBE3D;
                  border-color: #FDBE3D;
                }

                .icon-wechat {
                  position: relative;
                  color: #7bc549;
                  border-color: #7bc549;
                }

                .icon-weibo {
                  color: #ff763b;
                  border-color: #ff763b;
                }
              }
            }
          }


        }
      }
    }
  }

  .container {
    background-color: #fff;
    margin: 0;
    width: 100%;
    padding: 16px 44px;
    min-height: 600px;

    .nav {
      border-bottom: 1px solid #eaeaea;
      background-color: #fff;
      height: 41px;
    }

    .nav {
      padding-left: 0;
      margin-bottom: 0;
      list-style: none;

      li.on {
        color: #4286f5;
        border-bottom: 2px solid #4286f5;
      }

      li {
        float: left;
        display: inline-block;
        font-size: 18px;
        color: #333;
        padding: 0 25px;
        line-height: 41px;
        height: 41px;
        cursor: pointer;
      }
    }

    .nav-tabs>li {
      float: left;
      margin-bottom: -1px;
    }

    .nav>li {
      position: relative;
      display: block;
    }

    .tab-content {
      .row {
        margin-right: -15px;
        margin-left: -15px;
      }
    }
  }
}
</style>
